import { DesktopNavigationMenuProps, MobileNavigationMenuProps } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { selectLocale, selectMarket } from '../store/slices/globalConfigSlice';
import { useSelector } from 'react-redux';
import { selectAuth0Account, selectIsAuthenticated, selectUserProfile, signInWithAuth0, signOutWithAuth0 } from '../store/slices/userSlice';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const { t, i18n } = useTranslation('translation');
  const [desktopMenu, setDesktopMenu] = useState<DesktopNavigationMenuProps>();
  const [mobileMenu, setMobileMenu] = useState<MobileNavigationMenuProps>();
  const currentLocale = useSelector(selectLocale);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const account = useSelector(selectAuth0Account);
  const user = useSelector(selectUserProfile);
  const currentMartket = useSelector(selectMarket);
  const navigate = useNavigate()



  useEffect(() => {
    var signedInConfig = {
      items: [
        {
          label: t('Support Home'),
          to: '/',
          exact: true
        }
      ],
      buttons: [
        {
          type: 'profile'
        },
        {
          type: 'switcher',
          //@ts-ignore
          action: () => { window.globalNav?.show(); }
        },
      ],
      action: {
        label: t('Dashboard'),
        action: () => { window.location.href = process.env.REACT_APP_CONNECT_LINK ?? '' }
      },
    } as DesktopNavigationMenuProps;

    var unauthorizedConfig = {
      items: [
        {
          label: t('Support Home'),
          to: '/',
          exact: true
        }
      ],
      action: {
        action: () => {
          signInWithAuth0(window.location.href, i18n.language);
        },
        label: t('Login'),
      }
    } as DesktopNavigationMenuProps;


    setDesktopMenu(!!user ? signedInConfig : unauthorizedConfig);

    setMobileMenu({
      items: [
        {
          label: t('Support Home'),
          to: '/',
          exact: true
        }
      ],

    });
  }, [i18n.language, currentLocale, isAuthenticated, account, user]);


  useEffect(() => {

    if (process.env.REACT_APP_NEW_NAVIGATION?.toString() != 'true')
      return;

    //@ts-ignore
    window.laerdal.navigation.init({
      onLogout: () => {
        signOutWithAuth0();
      },
      onLogin: () => {
        signInWithAuth0(window.location.href, i18n.language);
      },
      menu: [{
        type: 'item',
        id: 'dashboardLink',
        label: t('Support Home'),
        to: '/',
        exact: true,
        active: '/' === location.pathname,
        action: () => {
          navigate(`/${currentMartket}`);
        },
      }],
      locale: i18n.language ?? 'en',
      market: !currentMartket ? 'en' : currentMartket,
      api: {
        connect: process.env.REACT_APP_CONNECT_LINK,
        account: process.env.REACT_APP_ACCOUNT_BASE,
        ecommerce: process.env.REACT_APP_ECOMMERCE_BASE,
        support: process.env.REACT_APP_SUPPORT_BASE
      },
    });

    //@ts-ignore
    window.laerdal.navigation.changeMarket(!currentMartket ? 'en' : currentMartket)

    //@ts-ignore
    if (window.laerdalGlobalNav?.onUpdateMarket) {
      //@ts-ignore
      window.laerdalGlobalNav?.onUpdateMarket(!currentMartket ? 'en' : currentMartket);
    }
  }, [i18n.language, currentMartket, user]);

  return (
    <>
      {/* @ts-ignore */}
      <laerdal-global-navigation-bar
        showcart={isAuthenticated ? "true" : "false"}
        showdashboard="true"
        showswitcher="true"
        showshopurl="true" />
    </>
  );
}

export default Header;

function dispatch(arg0: any) {
  throw new Error('Function not implemented.');
}
